// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(memberId) {
  return {
          memberId: memberId
        };
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_marketingProfileMember(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MarketingProfileMember"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"marketingProfileMember_MarketingProfileMember":{"f":""},"marketingProfileMember":{"u":"response_marketingProfileMember"}}};

var wrapResponseConverterMap = {
  response_marketingProfileMember: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"marketingProfileMember_MarketingProfileMember":{"f":""},"marketingProfileMember":{"u":"response_marketingProfileMember"}}};

var responseConverterMap = {
  response_marketingProfileMember: unwrap_response_marketingProfileMember
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = [
  {
    "kind": "Variable",
    "name": "memberId",
    "variableName": "memberId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMarketingProfileMemberQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "marketingProfileMember",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditMarketingProfileMember_page_marketingProfileMember"
                }
              ],
              "type": "MarketingProfileMember",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "EditMarketingProfileMemberQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "marketingProfileMember",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "licenseNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfilePhoto",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "ratio",
                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                      },
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 96
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileSocialAccounts",
                "kind": "LinkedField",
                "name": "socialAccounts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "twitter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "facebook",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "instagram",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkedIn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "youTube",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tikTok",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "yelp",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMember",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "712e5ba1f5431b3c1dd328319df9794e",
    "id": null,
    "metadata": {},
    "name": "EditMarketingProfileMemberQuery",
    "operationKind": "query",
    "text": "query EditMarketingProfileMemberQuery(\n  $memberId: ID!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  marketingProfileMember(memberId: $memberId) {\n    __typename\n    ... on MarketingProfileMember {\n      ...EditMarketingProfileMember_page_marketingProfileMember\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment EditMarketingProfileMemberInfoForm_marketingProfileMember on MarketingProfileMember {\n  firstName\n  lastName\n  licenseNumber\n  title\n  bio\n  id\n}\n\nfragment EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember on MarketingProfileMember {\n  id\n  firstName\n  displayName\n  socialAccounts {\n    twitter\n    facebook\n    instagram\n    linkedIn\n    youTube\n    tikTok\n    yelp\n  }\n}\n\nfragment EditMarketingProfileMember_header_marketingProfileMember on MarketingProfileMember {\n  id\n  displayName\n  firstName\n}\n\nfragment EditMarketingProfileMember_page_marketingProfileMember on MarketingProfileMember {\n  ...EditMarketingProfileMember_header_marketingProfileMember\n  ...EditMarketingProfileMemberInfoForm_marketingProfileMember\n  ...MarketingProfileMemberPhotoForm_agentMarketingProfile\n  ...EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember\n}\n\nfragment MarketingProfileMemberPhotoForm_agentMarketingProfile on MarketingProfileMember {\n  firstName\n  displayName\n  ...MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember\n  ...MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember\n}\n\nfragment MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember on MarketingProfileMember {\n  id\n  profilePicture {\n    __typename\n  }\n}\n\nfragment MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember on MarketingProfileMember {\n  profilePicture {\n    url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_marketingProfileMember = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_marketingProfileMember = unwrap_response_marketingProfileMember;
exports.wrap_response_marketingProfileMember = wrap_response_marketingProfileMember;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
